import { render, staticRenderFns } from "./donationUnitCustomFields.vue?vue&type=template&id=3f16a99e&"
import script from "./donationUnitCustomFields.vue?vue&type=script&lang=js&"
export * from "./donationUnitCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports